import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CsvShortcutSvg = function CsvShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.354V6.25c0 .138.113.25.25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.5 10.204A9 9 0 0 1 11 18a8.96 8.96 0 0 1-.935 4H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "m17.073 1.72 4.707 4.707c.142.142.22.33.22.53V21.75a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v7.954a9 9 0 0 0-.5-.268V2.25a.75.75 0 0 1 .75-.75h9.793c.199 0 .39.08.53.22m4.073 4.78L17 2.354V6.25a.25.25 0 0 0 .25.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    fillRule: "evenodd",
    d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9F7F7",
    fillRule: "evenodd",
    d: "M6.127 10q.15.076.294.159L6.341 10zm1.89 1.307L8.727 10h1.303l-1.26 2.07a9 9 0 0 0-.753-.763",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#33C481",
    fillRule: "evenodd",
    d: "M18 15.515h-.79v-.77h-.02q-.515.89-1.517.89-.713 0-1.14-.387-.43-.387-.43-1.042 0-1.378 1.628-1.609l1.478-.207q0-1.252-1.015-1.252-.89 0-1.609.601v-.809q.217-.164.741-.315a3.4 3.4 0 0 1 .935-.152q1.739 0 1.739 1.845zm-.79-2.495-1.195.169q-.611.087-.857.291-.245.206-.245.662a.74.74 0 0 0 .264.596q.265.223.68.223.587 0 .97-.415.382-.413.383-1.034zM19.232 17 20 14.635h-.767L18.672 17z",
    clipRule: "evenodd"
  }));
};
export var CsvShortcut = function CsvShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CsvShortcutSvg
  }));
};